import { Button, Message, Modal } from '@mairistem/composants';
import React from 'react';

interface ProfilEcritureResetModalProps {
	onCancel: () => void;
	onReset: () => void;
	open: boolean;
}

const ProfilEcritureResetModal = ({
	onCancel,
	onReset,
	open = false,
}: ProfilEcritureResetModalProps) => {
	return (
		<Modal open={open}>
			<Modal.Header content="Changement de profil" />
			<Modal.Content>
				<Message>
					<Message.Header content="Vous venez de changer de profil d'écriture, êtes-vous sûrs de vouloir le faire ?" />
					<p>Cela effacera tous les champs que vous aviez remplis</p>
				</Message>
			</Modal.Content>
			<Modal.Actions>
				<Button
					content="Oui"
					data-testid="profilEcritureResetModalOui"
					onClick={() => onReset()}
					positive
				/>
				<Button
					content="Non"
					data-testid="profilEcritureResetModalNon"
					negative
					onClick={() => onCancel()}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default ProfilEcritureResetModal;
